/* AJAX cart add for product-list cards; form POST remains the accessible fallback. */
document.addEventListener('submit',async function(event){
  const form=event.target.closest('[data-rebase-quick-add]');
  if(!form||!window.fetch)return;
  event.preventDefault();
  const button=form.querySelector('button[type="submit"]');
  const message=form.querySelector('[role="status"]');
  if(!button||button.disabled)return;
  const original=button.innerHTML;
  button.disabled=true;
  button.textContent='Hozzáadás…';
  if(message){message.textContent='';message.removeAttribute('data-error');}
  try{
    const url=new URL(form.action,window.location.href);
    url.pathname=url.pathname.endsWith('/')?url.pathname.slice(0,-1)+'.js':url.pathname+'.js';
    const response=await fetch(url.toString(),{
      method:'POST',body:new FormData(form),
      headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      credentials:'same-origin'
    });
    const result=await response.json().catch(()=>null);
    if(!response.ok)throw new Error(result&&typeof result.description==='string'?result.description:'A termék nem tehető a kosárba.');
    button.textContent='✓ Kosárba téve';
    if(message)message.textContent='Sikeresen a kosárba került.';
    try{
      const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      const cartResponse=await fetch(root+'cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}});
      if(cartResponse.ok){
        const cart=await cartResponse.json();
        const count=document.getElementById('cart-count');
        if(count&&typeof cart.item_count==='number')count.textContent=String(cart.item_count);
      }
    }catch(_cartError){/* Product was added; a failed counter refresh is not a failed add. */}
  }catch(error){
    button.textContent='Nem sikerült';
    if(message){message.textContent=error&&error.message||'Próbáld újra.';message.dataset.error='true';}
  }finally{
    window.setTimeout(function(){button.disabled=false;button.innerHTML=original;},2000);
  }
});
